export default {
      id: "arrowUp-usage",
      viewBox: "0 0 24 24",
      url: "assets/" + "sprite.svg#arrowUp-usage",
      toString: function () {
        return this.url;
      }
    }